<template>
  <div v-if="Number($page.props.manufacturer_id) || $page.props.category_id" class="mt-2 w-100">

    <ul class="list-unstyled d-flex flex-wrap mb-0">
      <template v-for="category in filteredCategories" :key="category.id">
        <li v-if="Number($page.props.manufacturer_id) && filteredCategories.length > 1" class="mr-2 my-1">
          <jet-button btnStyle="" class="btn-sm" @click="selectCategory(category)" :class="{'btn-primary': this.$page.props.category_id==category.id, 'btn-outline-secondary': this.$page.props.category_id!=category.id}">{{category.name}}</jet-button>
        </li>

        <template v-if="Number($page.props.manufacturer_id) &&filteredCategories.length === 1">
          <li v-for="childCategory in category.children" :key="childCategory.id" class="mr-2 my-1">
            <jet-button btnStyle="" @click="selectCategory(childCategory)" class="btn-sm" :class="{'btn-primary': this.$page.props.category_id==childCategory.id, 'btn-outline-secondary': this.$page.props.category_id!=childCategory.id}">{{childCategory.name}}</jet-button>
          </li>
        </template>
      </template>

      <template v-for="subcategory in selectedCategory" :key="subcategory.id">
        <li class="mr-2 my-1">
          <jet-button btnStyle="outline-secondary" @click="selectCategory(subcategory)" class="btn-sm">{{subcategory.name}}</jet-button>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        filteredCategories: []
      }
    },
    props: {
      categories: Array,
      category: Object,
      categoryRoute: String
    },
    mounted() {
      this.filterHotAndNew()
    },
    computed: {
      selectedCategory() {
        for (let i = 0; i < this.categories.length; i++) {
          if (this.categories[i].id === this.$page.props.category_id && this.categories[i].children.length) {
            return this.categories[i].children
          }
        }
      }
    },
    methods: {
      filterHotAndNew() {
        if (!this.$page.props.manufacturer_id) {
          return;
        }
        // Filter out new and hot item categories
        this.filteredCategories = this.categories.filter(cat => {
          return cat.id !== this.$page.props.const.cat_hot && cat.id !== this.$page.props.const.cat_new
        })
      },
      selectCategory(category) {
        this.$inertia.visit(this.route(this.categoryRoute, {
        category,
        _query: {
          manufacturer: this.$page.props.manufacturer_id,
          query: this.$page.props.query
        }
      }))
      }
    }
  }
</script>
